"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sync = (fn, ...args) => {
    return new Promise((resolve, reject) => {
        const obj = Object.assign({}, args[0]);
        const success = obj.success;
        obj.success = function (...params) {
            success && success.apply(this, ...params);
            const r = params.length > 1 ? params : params[0];
            resolve(r);
        };
        const fail = obj.fail;
        obj.fail = function (...params) {
            fail && fail.apply(this, ...params);
            const r = params.length > 1 ? params : params[0];
            reject(r);
        };
        fn(obj);
    });
};
exports.default = sync;
